import { orderBy } from 'lodash'
import { createSelector } from 'reselect'
import { WebchatLog, WebchatMessage, WEBCHAT_TIME_PROP } from '@feedyou/utils'

import { RootState } from '../../../../reducers'
import { initialState, TrySliceState, VisibleLogCategory } from './slice'
import {
  BEFORE_FIRST_MESSAGE,
  groupLogEntriesByPreviousMessage
} from './utils/groupLogEntriesByPreviousMessage'

const trySliceSelector = (state: RootState): TrySliceState => {
  return state.dock?.sections?.try ?? initialState
}

export function isTryDockRunningSelector(state: RootState): boolean {
  return trySliceSelector(state).isRunning
}

export function chatIntroDialogIdSelector(state: RootState): string | undefined {
  return trySliceSelector(state).introDialogId
}

export function visibleLogCategoriesSelector(state: RootState): VisibleLogCategory[] {
  return trySliceSelector(state)?.visibleLogCategories
}

export const visibleEventLogsSortedFromOldestSelector = createSelector(
  (state: RootState) => state.dock.sections.try.webchatLog,
  visibleLogCategoriesSelector,
  (webchatLog, visibleCategories): WebchatLog[] => {
    const visible = webchatLog.eventLogs.filter(isCategoryVisibleOrError(visibleCategories))
    return orderBy(visible, WEBCHAT_TIME_PROP, 'asc')
  }
)

function isCategoryVisibleOrError(visibleCategories: VisibleLogCategory[]) {
  return (entry: WebchatLog): boolean =>
    entry.category === 'error' || visibleCategories.includes(entry.category)
}

export const messagesSortedFromOldestSelector = createSelector(
  (state: RootState) => state.dock.sections.try.webchatLog.messages,
  (messages): WebchatMessage[] => orderBy(messages, WEBCHAT_TIME_PROP, 'asc')
)

export const visibleLogsPerLatestMessageSelector = createSelector(
  messagesSortedFromOldestSelector,
  visibleEventLogsSortedFromOldestSelector,
  (messagesFromOldest, visibleLogEntriesFromOldest) =>
    groupLogEntriesByPreviousMessage(messagesFromOldest, visibleLogEntriesFromOldest)
)

export const beforeFirstMessageWebchatLogsSelector = createSelector(
  visibleLogsPerLatestMessageSelector,
  (visibleLogsPerLatestMessage = {}): WebchatLog[] =>
    visibleLogsPerLatestMessage[BEFORE_FIRST_MESSAGE as any] || []
)
